module.exports = __webpack_public_path__ + "img/severin-candrian-watering-unsplash-300.b800d1fd.jpg";